import * as React from 'react';
import {
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  Grid,
  IconButton
} from '@mui/material';
import BakeasyTextField from '../../components/textfields/BakeasyTextField';
import { useState } from 'react';
import { AppContext } from '../../context/AppContext';
import { t } from 'i18next';
import { useAppDispatch } from '../../redux_store/reduxStore';
import { showErrorSnackbar } from '../../redux_store/slices/snackbarSlice';
import { BakeasyButtonClose, BakeasyButtonCreate } from '../../components/buttons/BakeasyButton';
import { addShippingMethod } from '../../redux_store/slices/shippingMethodsSlice';
import { Close } from '@mui/icons-material';

export const AddShippingMethod = (props: any) => {
  const dispatch = useAppDispatch();
  let myContext = React.useContext(AppContext);

  const [name, setName] = useState<string>('');

  function handleClose() {
    myContext.setDialog({ open: false });
    props?.onBack();
  }

  const checkValidity = (): boolean => {
    if (!name) {
      let msg = `${t('SHIPPING_METHOD_IS_REQUIRED')}`;
      dispatch(showErrorSnackbar({ message: msg }));
      return false;
    }
    return true;
  };

  async function onAddSubmit() {
    if (!checkValidity()) {
      return;
    }
    let payload = { methodName: name };

    await dispatch(addShippingMethod(payload));
    handleClose();
  }

  return (
    <>
      <DialogTitle
        sx={{ margin: 0, padding: 2 }}
        style={{ fontWeight: 600, fontSize: '1.2rem' }}
        minWidth={200}
      >
        <Grid container sx={{ flexDirection: 'row' }}>
          {t('ADD') + ' ' + t('SHIPPING_METHOD')}
        </Grid>
      </DialogTitle>
      <IconButton
        onClick={handleClose}
        sx={{ position: 'absolute', right: 8, top: 8, color: theme => theme.palette.grey[500] }}
      >
        <Close />
      </IconButton>
      <Divider />
      <DialogContent sx={{ margin: 0 }}>
        <Grid item xs={12} sm={12}>
          <BakeasyTextField
            label={t('SHIPPING_METHOD')}
            placeHolder={t('ENTER_SHIPPING_METHOD')}
            type="text"
            name="name"
            value={name}
            required={true}
            onChange={(event: any) => {
              setName(event.target.value);
            }}
          />
        </Grid>
      </DialogContent>
      <DialogActions sx={{ margin: 1 }}>
        <BakeasyButtonClose onClick={handleClose} />
        <BakeasyButtonCreate
          onClick={() => {
            onAddSubmit();
          }}
        />
      </DialogActions>
    </>
  );
};
